import BubbleChart from "@testboxlab/react-bubble-chart-d3";

type BubbleChartProps = {
  onBubbleClick?: any;
  onLegendClick?: any;
  data: any;
  width: number;
  height: number;
  font?: string;
  showLegend?: boolean;
};

export function WordBubbleWrapper(props: BubbleChartProps) {
  var showLegend = props.showLegend ? props.showLegend : false;
  var data = props.data.map((row) => {
    return {
      label: row.name,
      value: row.points,
      color: row.color ? row.color : null
    };
  });
  return (
    <BubbleChart
      graph={{
        zoom: 1,
        offsetX: -0.05,
        offsetY: -0.01,
      }}
      width={props.width}
      height={props.height}
      padding={0} // optional value, number that set the padding between bubbles
      showLegend={showLegend} // optional value, pass false to disable the legend.
      legendPercentage={25} // number that represent the % of with that legend going to use.
      legendFont={{
        family: "Arial",
        size: 12,
        color: "#000",
        weight: "bold",
      }}
      valueFont={{
        family: "Arial",
        size: 11,
        color: "#fff",
        weight: "bold",
      }}
      labelFont={{
        family: "Arial",
        size: 12,
        color: "#fff",
        weight: "bold",
      }}
      //Custom bubble/legend click functions such as searching using the label, redirecting to other page
      bubbleClickFun={props.onBubbleClick ? props.onBubbleClick : () => {}}
      legendClickFun={() => {}}
      data={data}
    />
  );
}
